// ----------------------------------------------------------------------------
// Component: Hero Carousel
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import $ from 'jquery';
import Swiper, { Navigation, Pagination, Scrollbar, A11y, Keyboard, Autoplay } from 'swiper';

// Styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import 'swiper/css/autoplay';
import 'snippets/background-media/background-media';
import './_hero-carousel.scss';

//Scripts for the Swiper slider
$(function() {
    $(".carousel--hero-carousel").each(function(index, element){
        var $this = $(this);

        // Generate unique class for each collection list slider
        $this.addClass("hero-carousel-instance-" + index);

        // Generate unique btn classes for swiper pagination
        $this
            .parents(".carousel-section--hero-carousel")
            .find(".swiper-pagination")
            .addClass("hero-carousel-swiper-pagination-" + index);

        var swiper = new Swiper(".hero-carousel-instance-" + index, {
            // Optional parameters
            modules: [Navigation, Pagination, Scrollbar, A11y, Keyboard, Autoplay],
            slidesPerView: 1,
            spaceBetween: 1,
            observer: true,
            showPagination: false,
            observeParents: true,
            a11y: false,
            watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.
            autoplay: {
                delay: 5000,
            },
            pagination: {
                el: ".hero-carousel-swiper-pagination-" + index,
                clickable: true,
            },
        });

        swiper.slides.forEach(function (slide, index) {
            let slideLink = slide.querySelector("a");

            if (slideLink) {
                slideLink.addEventListener("focus", function (e) {
                    swiper.slideTo(index);
                });
            }
        });

        // Shows specific slider based on #hash ID in URL
        $(window).on("load", function () {
            if (window.location.hash) {
                const heroCarousel = document.querySelector(
                    ".carousel-section--hero-carousel"
                );
                const hash = window.location.hash;
                const slide_id = document.querySelector(`.swiper-slide ${hash}`);

                if ( typeof slide_id !== "undefined" && typeof heroCarousel !== "undefined") {
                    const slideIndex = slide_id.dataset.index;
                    //const scrollFocus =heroCarousel.getBoundingClientRect().top + window.pageYOffset - 150;

                    swiper.slideTo(slideIndex);
                   // window.scrollTo({ top: scrollFocus, behavior: "smooth" });
                }
            }
        });
    });
});
